import { baseUrl } from '../../shared/utils';

import { MultiMessageError } from './types';

type PasswordAPIResponse =
  | { success: true }
  | {
      success: false;
      error: 'INVALID_TOKEN';
      message: string;
    }
  | {
      success: false;
      error: 'VALIDATION_ERROR';
      details: string[];
    }
  | {
      success: false;
      message?: string;
    };

/** Changes password and throws a MultiMessageError if it fails */
export async function changePassword({
  oneTimeToken,
  password,
}: {
  oneTimeToken: string;
  password: string;
}): Promise<void> {
  const response = await fetch(
    `${baseUrl.authms}/v1/auth/first-login/password`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        oneTimeToken,
        newPassword: password,
      }),
    }
  );

  const changePasswordResponse = await (async () => {
    try {
      return (await response.json()) as PasswordAPIResponse;
    } catch {
      return { success: false } as PasswordAPIResponse;
    }
  })();

  // Happy path
  if (changePasswordResponse.success) {
    return;
  }

  // Handle list of password validation errors
  if (
    'details' in changePasswordResponse &&
    changePasswordResponse.details.length
  ) {
    throw new MultiMessageError(changePasswordResponse.details);
  }

  // Handle errors w/ a message from the BE
  if ('message' in changePasswordResponse && changePasswordResponse.message) {
    throw new MultiMessageError([changePasswordResponse.message]);
  }

  // Handle anything else
  throw new MultiMessageError(['Unknown Error']);
}
